






import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * component for displaying a list of ItemBox components
 *
 * This component can be used as a simple wrapping container for ItemBox
 * components to keep their spacing and display consistent.
 *
 * It takes two optional parameters. `separator` specifies whether
 * the items should be in box-shadows (`box`) or have a single, bottom
 * border separating them (`line`). The `no-padding` parameter is a
 * Boolean parameter, meaning it doesn't need a value. If present,
 * the component's default, internal padding is removed so that it
 * can be styled by the parent component.
 */
@Component
export default class ItemBoxList extends Vue {
	@Prop({type: Boolean})
	noPadding!: boolean;

	@Prop({default: 'box'})
	separator!: 'box' | 'line';
}
